import React from 'react';
import enhance from './enhance';
import AddAllButton from '../AddAllButton';
import styles from '../styles.module.scss';
import SummaryBanner from '../../../SummaryBanner';
import { miniDisclaimer } from 'constants/values';

export const LockedModelHeader = ({
  addDisclaimer,
  basePriceFormatted,
  basePriceLabel,
  description,
  imgUrl,
  seriesDetailPageLoaded,
  hasTemplates,
  modelTitleStyle,
}) => (
  <div className={styles.modelHeader}>
    <div className={styles.modelBanner}>
      {addDisclaimer && (
        <div className={styles.disclaimer}>{miniDisclaimer}</div>
      )}
      <img className={styles.modelImg} src={imgUrl} alt="model" />
      <div>
        <h1 className={modelTitleStyle}>{description}</h1>
        <ul className={styles.modelSummary}>
          <li className={styles.summaryStat}>
            {basePriceLabel}: {basePriceFormatted}
          </li>
        </ul>
      </div>
    </div>
    <div className={styles.banner}>
      <SummaryBanner remaining="--" inCart="--" submitted="--" />
      {hasTemplates && (
        <AddAllButton locked seriesDetailPageLoaded={seriesDetailPageLoaded} />
      )}
    </div>
  </div>
);

export default enhance(LockedModelHeader);
